import axios from 'axios';
import Store from './Store';
import { applyBearerOrCookie } from './authStrategy';

function withAuth(config) {
  return applyBearerOrCookie(config, Store.getToken());
}

export default {
  name: 'RuleGroupService',
  rules: [
  ],
  create(rule) {
    return axios(withAuth({
      url: `${process.env.VUE_APP_DRIVE_SERVICE_URL}/rule_drive_group`,
      method: 'post',
      data: rule,
    }));
  },
  update(rule) {
    return axios(withAuth({
      url: `${process.env.VUE_APP_DRIVE_SERVICE_URL}/rule_drive_group/${rule.id}`,
      method: 'put',
      data: rule,
    }));
  },
  delete(rule) {
    return axios(withAuth({
      url: `${process.env.VUE_APP_DRIVE_SERVICE_URL}/rule_drive_group/${rule.id}`,
      method: 'delete',
    }));
  },
  findAllRuleGroups() {
    return axios(withAuth({
      url: `${process.env.VUE_APP_DRIVE_SERVICE_URL}/rule_drive_group`,
      method: 'get',
    }));
  },
  findRuleGroupsByTermAndUserRole(term, userRole, paramsPage) {
    paramsPage.append('term', term);
    paramsPage.append('userRole', userRole);

    return axios(withAuth({
      url: `${process.env.VUE_APP_DRIVE_SERVICE_URL}/rule_drive_group/findAllByTermAndUserRole`,
      method: 'get',
      params: paramsPage,
    }));
  },
};
